import BaseDomain from '../../../states/domains/BaseDomain';

const SEARCH_STUDENT_UPDATE_CRITERIA_AND_DATA = 'SEARCH_STUDENT_UPDATE_CRITERIA_AND_DATA';
const SEARCH_STUDENT_UPDATE_CRITERIA = 'SEARCH_STUDENT_UPDATE_CRITERIA';

const initialState = {
  criteria: {
    username: '',
    firstName: '',
    lastName: '',
  },
  studentList: {
    data: [],
    included: [],
  },
  hasLoaded: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case SEARCH_STUDENT_UPDATE_CRITERIA_AND_DATA:
      return {
        ...state,
        criteria: action.payload.criteria,
        studentList: action.payload.studentList,
        hasLoaded: action.payload.hasLoaded,
      };
    case SEARCH_STUDENT_UPDATE_CRITERIA:
      return {
        ...state,
        criteria: action.payload,
      };
    default:
      return state;
  }
};

const domainName = 'searchStudentDomain';

/**
 * Domain class for search student in admin
 *
 * @export
 * @class UiDomain
 * @extends {BaseDomain}
 */
export default class extends BaseDomain {
  constructor(saveToLocalStorage) {
    super(domainName, initialState, reducer, saveToLocalStorage);
  }

  async updateCriteriaAndStudentList(criteria, studentList, hasLoaded = true) {
    return this.dispatch({
      type: SEARCH_STUDENT_UPDATE_CRITERIA_AND_DATA,
      payload: {
        criteria,
        studentList,
        hasLoaded,
      },
    });
  }

  async updateCriteria(criteria) {
    return this.dispatch({
      type: SEARCH_STUDENT_UPDATE_CRITERIA,
      payload: criteria,
    });
  }
}
